import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  year: number;
  appUrl: string = environment.appUrl;

  constructor() {
    this.year = new Date().getFullYear();
  }
}
